const red300Color = '#D77575';

export default red300Color;
